// Features Craig has hidden for now without parking them on a branch. Their data, code and links
// stay; only the ways in are turned off, so turning one back on is this one line.

// Vision is hidden while Craig tries Dreams and Fears on their own (Craig, 17 Oct 2026: "I'm a little
// unclear on my own opinion regarding the fit for Vision in addition to Dreams and Fears. What I'd like
// to try is to hide Vision from the app temporarily."). Hides Radar's "What Matters Most" group. Its only
// way in was a row on My Plan, which was parked on 23 Oct 2026: turning this on also needs a new way in
// (a Home tile, say).
export const VISION_SHOWN = false;

// Home's "Life is hard" and "How Nudge helps" card is hidden while Craig simplifies the app (Craig, 21 Oct
// 2026: "Let's comment out the Life is Hard and How Nudge helps card. Let's not delete it yet. I might want
// to move some or all of it to the popup help menu."). The card and its words stay in HomePage.jsx.
export const HOME_STORY_SHOWN = false;
